require('../../scripts/PersonalizedServices/AiAvatar/main');
require('../../scripts/Tools/old-description');

require('../../../../sass/website/PersonalizedServices/AiAvatar/main.scss');